const RULES = {
  event: 'galleryClicked',
  required: ['listingId', 'action', 'photosCount']
};
const EVENTS = {
  swipeGallery: {
    action: 'SWIPE'
  },
  openGallery: {
    action: 'OPEN'
  }
};
const create = (event, data = {}) => {
  const {
    listing: {
      listing: {
        id: listingId = ''
      } = {},
      medias = []
    } = {},
    current,
    screen: rawScreen = '',
    subject = 'PHOTO BUTTON',
    action
  } = data;
  const {
    length: photosCount = 0
  } = medias.filter(media => media.type === 'IMAGE');
  const currentPhotoPosition = Number(current) + 1;
  const screen = `${rawScreen} GALLERY`;
  if (!EVENTS[event]) {
    const allowedEvents = Object.keys(EVENTS).join(', ');
    throw new TypeError(`Only these events are compatible with this schema: ${allowedEvents}`);
  }
  return {
    gallery: {
      listingId,
      screen,
      action,
      subject,
      currentPhotoPosition,
      photosCount,
      ...EVENTS[event]
    },
    ...data,
    event: 'galleryClicked'
  };
};
var galleryClicked = {
  create,
  RULES
};

export { galleryClicked as default };
